import React from 'react';

import ProductMap from '../../product/components/product-map';
import ProductShow from '../../product/components/product-show';
import ProductShowPlaceHolder from '../../product/components/product-show-placeholder';

class VWAProductList extends React.PureComponent {
    productItem = (product, key, enableAppPDP, className, i, placeholder) => {
        const {
            toggleCompareDrag,
            disableCompare,
            slugKey,
            pg='plp',
            productCard
        } = this.props;
        const { disableJumpId=true } = productCard;

        if(placeholder){
            return <ProductShowPlaceHolder product={product} />
        }
        
        return (
            <ProductShow
                key={key}
                product={product}
                fetchSpecs={this.fetchTechSpecs}
                toggleCompareDrag={toggleCompareDrag}
                disableCompare={disableCompare}
                jumpInfo={!disableJumpId ? { slugKey, pg: pg } : undefined}
                enableAppPDP={enableAppPDP}
                saleCalloutPath="violatorMsg"
                hideMktDiff={true}
            />
        );
    }

    render() {
        const {
            enableAppPDP=true,
            results,
        } = this.props;

        return (
            <div className="products-list">
                <ProductMap
                    products={results}
                    productItem={this.productItem}
                    enableAppPDP={enableAppPDP}
                    customPlaceHolder={true}
                />
            </div>
        );
    }
}

export default VWAProductList;
